/** Linear review wizard: Intent → Orchestrate → Output → [Artefacts] → Submit. */

export const CORE_WIZARD_STEPS = ["intent", "orchestrate", "output"] as const;
export type CoreWizardStep = (typeof CORE_WIZARD_STEPS)[number];

export const ARTEFACTS_STEP = "artefacts" as const;
export const SUBMIT_STEP = "submit" as const;

export type WizardStep = CoreWizardStep | typeof ARTEFACTS_STEP | typeof SUBMIT_STEP;

export const WIZARD_STEP_LABELS: Record<WizardStep, string> = {
  intent: "Intent",
  orchestrate: "Orchestrate",
  output: "Output",
  artefacts: "Artefacts",
  submit: "Submit",
};

export function wizardStepsForRun(hasArtefacts: boolean): WizardStep[] {
  if (hasArtefacts) {
    return [...CORE_WIZARD_STEPS, ARTEFACTS_STEP, SUBMIT_STEP];
  }
  return [...CORE_WIZARD_STEPS, SUBMIT_STEP];
}

/** @deprecated use wizardStepsForRun */
export const WIZARD_STEPS = wizardStepsForRun(false);

export function wizardStepIndex(step: WizardStep, hasArtefacts: boolean): number {
  return wizardStepsForRun(hasArtefacts).indexOf(step);
}

export function nextWizardStep(step: WizardStep, hasArtefacts: boolean): WizardStep | null {
  const steps = wizardStepsForRun(hasArtefacts);
  const i = steps.indexOf(step);
  return i < steps.length - 1 ? steps[i + 1] : null;
}

export function prevWizardStep(step: WizardStep, hasArtefacts: boolean): WizardStep | null {
  const steps = wizardStepsForRun(hasArtefacts);
  const i = steps.indexOf(step);
  return i > 0 ? steps[i - 1] : null;
}
